import React from 'react';

export const calculateValueContentWidth = (
  newAmount: number,
  inputWrapperRef: React.RefObject<HTMLDivElement>
): number => {
  const span = document.createElement('span');
  span.style.visibility = 'hidden';
  span.style.whiteSpace = 'nowrap';
  span.style.fontSize = '36px'; // Match the input's font size
  span.style.fontWeight = '500'; // Match the input's font weight

  // Use the full value for the width calculation, including decimals if present
  const valueToDisplay = newAmount.toString(); // Display full value, including decimals if needed
  span.textContent = valueToDisplay;

  // Append span to the wrapper div for width calculation
  inputWrapperRef.current?.appendChild(span);

  // Calculate width of the span element
  const calculatedWidth = span.offsetWidth + 30; // Add padding to avoid clipping
  inputWrapperRef.current?.removeChild(span); // Clean up by removing the span element

  return Math.min(Math.max(50, calculatedWidth), 200); // Cap at max width of 200px
};

export const ensureHttpsLink = (link: string) => {
  // Remove any leading/trailing whitespace
  const trimmedLink = link.trim();

  // Check if the link starts with "http://" or "https://"
  if (trimmedLink.startsWith('http://')) {
    // Replace "http://" with "https://"
    return trimmedLink.replace('http://', 'https://');
  } else if (!trimmedLink.startsWith('https://')) {
    // Prepend "https://" if neither "http://" nor "https://" is present
    return `https://${trimmedLink}`;
  }

  // Return the link if it already starts with "https://"
  return trimmedLink;
};

// Helper function to build URLs with query parameters
export const buildUrlWithParams = (baseUrl: string, params: Record<string, any> = {}): string => {
  const url = new URL(baseUrl);
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    // Only add parameters that have truthy values
    if (value !== null && value !== undefined && value !== '') {
      // Handle arrays by joining them
      if (Array.isArray(value) && value.length > 0) {
        searchParams.append(key, value.join(','));
      } else if (!Array.isArray(value)) {
        searchParams.append(key, value.toString());
      }
    }
  });

  url.search = searchParams.toString();
  return url.toString();
};

// Helper function to compare arrays
export const arraysEqual = (a: any[], b: any[]): boolean => {
  if (a.length !== b.length) return false;
  return a.every((val, index) => val === b[index]);
};

export const CURRENCY_USD = 'USD';
export const CURRENCY_usd = 'usd';
export const DEFAULT_CPM_VALUE = 20;

export const currencyOptions = [
  { value: 'USD', text: '🇺🇸 USD $' },
  { value: 'EUR', text: '🇪🇺 EUR €' },
  { value: 'GBP', text: '🇬🇧 GBP £' },
  { value: 'CAD', text: '🇨🇦 CAD C$' },
  { value: 'AUD', text: '🇦🇺 AUD A$' },
];

export const getCurrencySymbol = (currencyCode: string) => {
  const symbols = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    CAD: 'C$',
    AUD: 'A$',
  };
  return symbols[currencyCode as keyof typeof symbols] || '$';
};
